module.exports = __webpack_public_path__ + "media/images/banner/japanesecrafts/id-bc607ab03eb33818e6c6cce68c43949f.png";